/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

interface IProps {
  top: string;
  right?: string;
  bottom: string; // e.g 0px(O) 0(X)
  left?: string;
  width?: string;
  height?: string;
  backgroundColor?: string;
  children?: React.ReactNode;
}

const Wrapper = styled.div<IProps>`
  position: fixed;
  top: ${(props) => `calc(${props.top})`};
  right: ${(props) => props.right};
  bottom: ${(props) => `calc(${props.bottom})`};
  left: ${(props) => props.left};
  overflow: hidden;
  background-color: ${(props) => props.backgroundColor};
`;

const Content: React.FC<IProps> = ({
  children,
  top,
  right = '0px',
  bottom,
  left = '0px',
  width = 'auto',
  height = 'auto',
  backgroundColor = 'transparent',
}) => {
  return (
    <Wrapper
      top={top}
      right={right}
      bottom={bottom}
      left={left}
      width={width}
      height={height}
      backgroundColor={backgroundColor}>
      {children}
    </Wrapper>
  );
};

export default Content;
